import React, { Component } from 'react';
import PropTypes from 'prop-types';


const styleCanvas = {
    // border :'3px solid grey',
    maxWidth: 100,
    maxHeight: 100
};


class FileIcon extends Component {


    state = {
        hasCanvas: true
    };

    static propTypes = {
        item: PropTypes.object,
        thumb: PropTypes.string
    }


    componentDidMount() {

        if(!this.props.thumb && this.props.item.type.startsWith('image')){
            this.createCanvas();
        }
        else{
            this.setState({hasCanvas:false})
        }


    }

    createCanvas() {
        var that = this;

        const canvas = this.refs.canvas;
        const ctx = canvas.getContext('2d');

        var img = new Image();
        img.onload = function(){
            canvas.width = this.width;
            canvas.height = this.height;

            ctx.drawImage(img, 0, 0);


        };

        var URLObj = window.URL || window.webkitURL;
        img.src = URLObj.createObjectURL(this.props.item);



    }




    render() {

        const { item, thumb } = this.props;
        let { hasCanvas } = this.state;

        if(hasCanvas){
            return <canvas className="preview" ref="canvas" style={styleCanvas} />;
        }
        else{
            if(this.props.item.type.startsWith('image')){
                return <img className="preview" src={thumb}  />;
            }
            else{
                // return <img src={'../../assets/images/mime-types/' + item.type.replace('/','-') + '.svg'} alt={item.type} />;
                return <img className="preview" src={'../../assets/images/mime-types/general.svg'} alt={item.type} />;
            }
        }



    };

}

export default FileIcon;


// WEBPACK FOOTER //
// ./src/modules/notes/FileIcon.js